var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "提示文字" } },
        [
          _c("el-input", {
            attrs: {
              size: "small",
              placeholder: "请选择",
              maxlength: "50",
              "show-word-limit": "",
            },
            model: {
              value: _vm.value.placeholder,
              callback: function ($$v) {
                _vm.$set(_vm.value, "placeholder", $$v)
              },
              expression: "value.placeholder",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "日期格式" } },
        [
          _c(
            "el-select",
            {
              staticClass: "width-100",
              attrs: { size: "small" },
              model: {
                value: _vm.value.format,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "format", $$v)
                },
                expression: "value.format",
              },
            },
            [
              _c("el-option", {
                attrs: { value: "yyyy-MM-dd", label: "年-月-日" },
              }),
              _c("el-option", {
                attrs: {
                  value: "yyyy-MM-dd HH:mm:ss",
                  label: "年-月-日 时:分:秒",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }